import { useEffect, useRef, useState } from "react";
import STATE from "../../constanta/state";
import axios from "axios";
import CONFIG from "../../constanta/config";
import CountdownTimer from "../../components/countdownTimer";
import CardFinish from "../match-image/components/cardFinish";
import CardDiskualifikasi from "../../components/cardDiskualifikasi";
import Quiz from "./Quiz";
import LogoApp from "../../components/logoapp";

const GameQuiz = (props) => {
  const { user, game, idActivity, config, activity } = props;
  const [state, setState] = useState();
  const [duration, setDuration] = useState(0);
  const [finish, setFinish] = useState(false);
  const [gameSetting, setGameSetting] = useState(null);
  const [questionDetails, setQuestionDetails] = useState([]);
  const timeout = useRef(null);
  const [msgError, setMsgError] = useState("");

  // useEffect(() => {
  //   const timerId = setInterval(() => {
  //     setSeconds(prevSeconds => prevSeconds + 1);
  //   }, 1000);

  //   // Clean up the timer on component unmount
  //   return () => clearInterval(timerId);
  // }, []);

  useEffect(() => {
    const handler = (event) => {
      if (state !== STATE.FINISH && state !== STATE.FAIL) {
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handler);
    return () => {
      window.removeEventListener("beforeunload", handler);
    };
  }, [state]);

  useEffect(() => {
    // if (props.score !== "" && JSON.parse(props.gameData).length > 0) {
    //   //console.log("FINISH")
    //   setDuration(props.score);
    //   setQuestionDetails(JSON.parse(props.gameData));
    //   setState(STATE.FINISH);
    // } else if (props.score === "0" && JSON.parse(props.gameData).status === "playing") {
    //   //console.log("FAIL")
    //   setState(STATE.FAIL);
    // } else {
    //   //console.log("START")
    //   setState(STATE.START);
    // }

    setState(STATE.START);
  }, [props.score]);

  const handleFinishGame = (score, questionDetails) => {


    setQuestionDetails(questionDetails);
    setDuration(score);
    postScore(score, questionDetails);
  };

  const postScore = async (score, gameData) => {
    let totalTimer = gameData.reduce((total, item) => total + item.timer, 0);
    setFinish(true);

    const payload = {
      score: score,
      game_data: JSON.stringify(gameData),
      play_time: totalTimer,
      name: user.name
    };


    var form_data = new FormData();

    for (var key in payload) {
      form_data.append(key, payload[key]);
    }

    axios
      .post(CONFIG.URL + "/score?rnd=" + Date.now(), form_data, {
        headers: {
          token: 'eyJpZF9hZG1pbiI6IjEiLCJ0b2tlbiI6ImY1U3FLakdoVDZEeG50YTdFMXNQMSIsInJvbGUiOiJzdXBlcl9hZG1pbiJ9.S8P4yA7hTZ9lpQqOyrTKcl4wdrLq8S_tcUZdLo9pDWY',
        },
      })
      .then(function (response) {
        if (response.data.status === "SUCCESS") {
          setState(STATE.FINISH);
        } else {
          setState(STATE.ERROR);
          setMsgError("Error: " + JSON.stringify(response?.data));
        }
        setFinish(false);
      })
      .catch(function (error) {
        setState(STATE.ERROR);
        setFinish(false);
        setMsgError("Error: " + JSON.stringify(error));
      });
  };

  useEffect(() => {
    if (game) {
      let setting = JSON.parse(game.game_setting);
      setGameSetting(setting);
    }
  }, [game]);

  const handleComplete = () => {
    alert("Countdown completed!");
  };

  return (
    <>
      <div className="bg-[#ffffffd9] flex flex-col md:flex-row justify-between items-center w-full px-4 py-2">
        <div className="flex justify-center md:justify-start items-center w-full font-bold text-2xl">
          {game?.name}
        </div>

        <div className="flex justify-center md:justify-end items-center w-full font-bold text-2xl">
          <div className="text-black font-bold text-lg md:text-2xl whitespace-nowrap">
            {user?.name}
          </div>{" "}

        </div>

      </div>

      {finish && (
        <div className="fixed z-50 h-screen w-screen bg-[#000000b3] text-white flex justify-center items-center font-semibold text-lg">
          Please wait while we calculate your score
        </div>
      )}

      {state === STATE.ERROR && (
        <div className="fixed z-50 min-h-screen w-screen bg-[#000000b3] text-white flex flex-col justify-center items-center font-semibold text-lg">
          <div>There is a problem with your connection, please press the button below</div>
          <div className="flex mt-4 justify-between w-full">
            <div
              onClick={() => postScore(duration, questionDetails)}
              className="font-bold cursor-pointer w-full flex justify-center items-center text-lg text-white py-2 px-2 border-b-4 border-green-700 bg-green-500 rounded-lg "
            >
              TRY AGAIN!
            </div>
          </div>
        </div>
      )}

      {state === STATE.START && (
        <CountdownTimer onComplete={() => setState(STATE.GAME)} />
      )}

      {state === STATE.GAME && (
        <div className="flex flex-col justify-center items-center flex-grow w-full p-2">
          <div className="flex w-full justify-center items-center">
            <LogoApp />
          </div>
          <div className="container flex justify-center items-center w-full">
            <Quiz
              activity={activity}
              questions={gameSetting.data}
              timer={gameSetting.timer}
              name={user?.firstname + " " + user?.lastname}
              handleFinishGame={(score, questionDetails) =>
                handleFinishGame(score, questionDetails)
              }
            />
          </div>
        </div>
      )}

      {state === STATE.FINISH && (
        <div className="flex flex-col justify-center items-center flex-grow w-full p-5">
          <CardFinish
            name={user?.name}
            activity={activity}
            score={duration}
            user={user}
            game={game}
            questionDetails={questionDetails}
          />
        </div>
      )}

      {state === STATE.FAIL && (
        <div className="flex flex-col justify-center items-center flex-grow w-full p-5">
          <CardDiskualifikasi
            duration={duration}
            user={user}
            game={game}
            config={config}
            activity={activity}
          />
        </div>
      )}
    </>
  );
};

export default GameQuiz;
